const md = require('markdown-it')({ html: false });
const externalLinks = require('markdown-it-external-links');

const internalDomains = ['paperform.co', 'papersign.com', 'localhost'];

md.use(externalLinks, {
  internalDomains,
  externalTarget: '_blank',
});

export default function isExternalURL(link) {
  if (!link) return false;

  return (
    link.startsWith('http') && !internalDomains.some((d) => link.includes(d))
  );
}

export function handleExternalUrlsInMarkdown(markdown) {
  if (!markdown) return '';
  return md.render(markdown);
}
